import { useBreakpointValue } from 'utils/mediaQuery';

type UseSearchSplitLayoutOptions = {
  /** Whether a search result is being previewed. */
  isPreviewing: boolean;
};

type UseSearchSplitLayoutResult = {
  /** The size of the left column. */
  leftColumnSize: string;
  /** The size of the right column. */
  rightColumnSize: string;
};

export const useSearchSplitLayout = ({
  isPreviewing,
}: UseSearchSplitLayoutOptions): UseSearchSplitLayoutResult => {
  const isSmallScreen = useBreakpointValue({ base: true, md: false });

  const leftColumnSize = isSmallScreen ? (isPreviewing ? '0' : '100%') : '40%';
  const rightColumnSize = isSmallScreen ? (isPreviewing ? '100%' : '0') : '60%';

  return { leftColumnSize, rightColumnSize };
};
